import { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";
import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";
import ClaimsTable from "../../components/tables/ClaimsTable.jsx";
import ClaimsSearchBar from "../../components/ClaimsSearchBar.jsx";
import { useSearchParams } from "react-router";

/**
 * Schaden List Page
 * Shows a list of damages/claims
 */
export default function ClaimIndexPage() {
  const { setBreadcrumbs } = useBreadcrumb();
  const [searchParams, setSearchParams] = useSearchParams();
  const [scope, setScope] = useState(searchParams.get(`scope`) || "mine");

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Schäden", path: "/schaeden" },
    ]);
  }, [setBreadcrumbs]);

  useEffect(() => {
    setScope(searchParams.get(`scope`));
  }, []);

  const handleOnChangeScope = (scope) => {
    setSearchParams(
      (currentParams) => {
        const params = new URLSearchParams(currentParams);
        params.set(`scope`, scope);
        return params;
      },
      { preventScrollReset: true }
    );
  };

  return (
    <Box>
      {/* Page Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h1" gutterBottom>
          Schäden
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Übersicht aller Schadenmeldungen
        </Typography>
      </Box>

      {/* Claims search and create */}
      <Box sx={{ mb: 4 }}>
        <ClaimsSearchBar />
      </Box>

      {/* Claims Table */}
      <ClaimsTable
        variant="full"
        onChangeScope={handleOnChangeScope}
        initalScope={scope}
      />
    </Box>
  );
}
